import { DateTime } from 'luxon';

export function toHumanReadable(date: Date) {
  return DateTime.fromJSDate(date).toRelative();
}
